import {
    GET_MERCHANT_INVOICE_LIST_FAILED,
    GET_MERCHANT_INVOICE_LIST_SUCCESS,
    GET_MERCHANT_INVOICE_LIST_LOADING,
    REMOVE_MERCHANT_INVOICE_LIST
} from "../types";

const initialState = {
    loading: false,
    error: null,
    InvoicesList: null,
};

export const merchantInvoicesReducer = (
    state = initialState,
    action: { type: any; loading: any; payload: any; error: any }
) => {
    switch (action.type) {
        case GET_MERCHANT_INVOICE_LIST_LOADING:
            return {
                ...state,
                loading: action.loading,
                error: null,
            };
        case GET_MERCHANT_INVOICE_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                InvoicesList: action.payload,
                error: null,
            };
        case GET_MERCHANT_INVOICE_LIST_FAILED:
            return {
                ...state,
                loading: false,
                InvoicesList: null,
                error: action.error,
            };
        case REMOVE_MERCHANT_INVOICE_LIST:
            return initialState;
        default:
            return state;
    }
};
